interface SendMessageOptions {
  apiBase: string
  agentId: string
  sessionId: string
  conversationId: string | null
  message: string
  onDelta: (chunk: string) => void
  onDone: (fullText: string, conversationId: string) => void
  onError?: (message: string) => void
}

/**
 * Envía un mensaje al backend usando Fetch + ReadableStream (SSE).
 * NO usa EventSource porque solo soporta GET y no puede enviar body.
 */
export async function sendMessage(opts: SendMessageOptions) {
  const res = await fetch(`${opts.apiBase}/api/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      agentId: opts.agentId,
      sessionId: opts.sessionId,
      conversationId: opts.conversationId,
      message: opts.message,
    }),
  })

  if (!res.ok) {
    const err = await res.text()
    throw new Error(`Chat API error ${res.status}: ${err}`)
  }

  if (!res.body) throw new Error('No response body')

  const reader = res.body.getReader()
  const decoder = new TextDecoder()
  let buffer = ''
  let fullText = ''
  let cid = opts.conversationId ?? ''

  while (true) {
    const { done, value } = await reader.read()
    if (done) break

    buffer += decoder.decode(value, { stream: true })
    const lines = buffer.split('\n')
    buffer = lines.pop() ?? ''

    for (const line of lines) {
      if (!line.startsWith('data: ')) continue
      const raw = line.slice(6).trim()
      if (!raw) continue

      try {
        const event = JSON.parse(raw)
        if (event.type === 'delta') {
          fullText += event.text
          opts.onDelta(event.text)
        } else if (event.type === 'done') {
          fullText = event.fullText ?? fullText
          cid = event.conversationId ?? cid
          opts.onDone(fullText, cid)
        } else if (event.type === 'error') {
          opts.onError?.(event.message ?? 'Error desconocido')
        }
      } catch {
        // skip malformed lines
      }
    }
  }
}
